import { useEffect, useMemo, useState } from 'react';

import appService from '../../service/app.service';
import masterDataService from '../../service/masterData.service';
import { ButtonUI, DebouncedInputUI } from '../Interface';
import DynamicFormRoleModify from './DynamicFormRoleModify';

const DynamicFormRoleInformation = ({ roleState }) => {
  const { roleId } = roleState;
  const [dynamicForms, setDynamicForms] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [selectedDynamicFormId, setSelectedDynamicFormId] = useState(null);
  const [roleHasPermission, setRoleHasPermission] = useState(false);
  const [roleModalShow, setRoleModalShow] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [filter, setFilter] = useState({ name: '' });

  useEffect(() => {
    masterDataService.getDynamicFroms().then((data) => {
      setDynamicForms(data.filter((form) => form.worksheet));
    });
  }, []);

  useEffect(() => {
    if (!roleId) {
      setPermissions([]);
      return;
    }

    appService.getDynamicFormPermissions(roleId).then((data) => {
      setPermissions(data);
    });
  }, [roleId, refreshPage]);

  const dynamicFormRoles = useMemo(
    () =>
      dynamicForms.map((form) => ({
        ...form,
        hasPermission: permissions.some(
          (permission) => permission.dynamicFormId === form.id && permission.roleId === roleId
        ),
      })),
    [dynamicForms, permissions, roleId]
  );

  return (
    <>
      <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6 max-h-[calc(100vh-10rem)] overflow-y-auto custom-scrollbar">
        <div className="w-[250px] mb-3">
          <DebouncedInputUI
            label="Keresés"
            debounceMs={800}
            quickFilterSearchValue={filter.name}
            setQuickFilterSearchValue={(name) => setFilter({ name })}
          />
        </div>
        <table className="mt-2 min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Munkalap
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Jogosult
              </th>
              <th className="px-6 py-3" />
            </tr>
          </thead>
          <tbody>
            {dynamicFormRoles
              .filter((form) => form.name.toLowerCase().includes(filter.name.toLowerCase()))
              .map((form, index) => (
                <tr key={form.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}>
                  <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{form.name}</td>
                  <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                    {form.hasPermission ? 'Jogosult' : 'Nem jogosult'}
                  </td>
                  <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                    <ButtonUI
                      onClick={() => {
                        setRoleModalShow(true);
                        setRoleHasPermission(form.hasPermission);
                        setSelectedDynamicFormId(form.id);
                      }}
                      variant="gradient"
                      color="blue-gray"
                      size="sm"
                      disabled={!roleId}
                      text="Szerkesztés"
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <DynamicFormRoleModify
        show={roleModalShow}
        onHide={() => setRoleModalShow(false)}
        hasPermission={roleHasPermission}
        roleId={roleId}
        dynamicFormId={selectedDynamicFormId}
        refreshPage={refreshPage}
        setRefreshPage={setRefreshPage}
      />
    </>
  );
};

export default DynamicFormRoleInformation;
